module.exports = require("./os-RU.js");